import script from "./node-usage-details-description.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./node-usage-details-description.vue?vue&type=script&setup=true&lang=ts"
export * from "./node-usage-details-description.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./node-usage-details-description.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__